var React = require('react');

function IconLinkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21,21H17V14.25C17,13.19 15.81,12.31 14.75,12.31C13.69,12.31 13,13.19 13,14.25V21H9V9H13V11C13.66,9.93 15.36,9.24 16.5,9.24C19,9.24 21,11.28 21,13.75V21M7,21H3V9H7V21M5,3A2,2 0 0,1 7,5A2,2 0 0,1 5,7A2,2 0 0,1 3,5A2,2 0 0,1 5,3Z"}));
}

IconLinkedin.displayName = "IconLinkedin";

IconLinkedin.defaultProps = {"version":"1.1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconLinkedin;

IconLinkedin.default = IconLinkedin;



//////////////////
// WEBPACK FOOTER
// ./~/svg-react-loader/lib/loader.js!./src/img/icon-linkedin.svg
// module id = 387
// module chunks = 35783957827783